
import { useState, useEffect } from "react";
import { fetchCourses, getBusinessGroups, addCourse } from "PlatForms/OrgLMS/Services/AdminServices/CourseListService";

export const useCourseList = () => {
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [businessGroups, setBusinessGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
    fetchAllCourses();
    fetchBusinessGroupsList();
  }, []);

  const fetchAllCourses = async () => {
    try {
      setLoading(true);
      const data = await fetchCourses(); 
      console.log("//////////////////corses",data);
      setCourses(data);
      setFilteredCourses(data);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setCourses([]);
      setFilteredCourses([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchBusinessGroupsList = async () => {
    try {
      const data = await getBusinessGroups();
      setBusinessGroups(data);
    } catch (error) {
      console.error("Error fetching business groups:", error);
      setBusinessGroups([]);
    }
  };

  const filterCourses = (groupId) => {
    if (!groupId) {
      setFilteredCourses(courses);
      setSelectedGroup(null);
      return;
    }
    
    const filtered = courses.filter(
      (course) => course.businessGroupId === groupId
    );
    setFilteredCourses(filtered);
    setSelectedGroup(groupId);
  };

  const AddCourse = async (courseData) => {
    try {
      setSubmitLoading(true);
      const newCourse = await addCourse(courseData);
      return newCourse;
    } catch (error) {
      throw error;
    } finally {
      setSubmitLoading(false);
    }
  };

  return {
    courses,
    filteredCourses,
    businessGroups,
    loading,
    submitLoading,
    selectedGroup,
    fetchCourses: fetchAllCourses,
    fetchBusinessGroups: fetchBusinessGroupsList,
    AddCourse,
    filterCourses,
    setCourses,
  };
};